import { IconButton, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const RepresentativesContainer = styled('ul')(({ theme }) => ({
  display: 'grid',
  gap: 30,
  width: '100%',
  gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr)) !important',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr)) !important',
  },
  [theme.breakpoints.up(1600)]: {
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr)) !important',
  },
}));

export const CameraIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
  '&:hover': {
    backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
  },
}));
